import { getText, TEXT_KEY } from '../../utils/localization';
export var FlowBehaviours = {
  SUBMIT: getText(TEXT_KEY.SUBMIT),
  GO_TO_NEXT_STEP: getText(TEXT_KEY.NEXT_STEP)
};